"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.on=function(e,t){document.addEventListener(e,t)},exports.off=function(e,t){document.removeEventListener(e,t)};


//////////////////
// WEBPACK FOOTER
// ./node_modules/dingtalk-jsapi/lib/bridge/h5Event.js
// module id = L0sZ
// module chunks = 23